module.exports = __webpack_public_path__ + "img/local-payments.74e721a.png";